module.exports = __webpack_public_path__ + "static/3-da9245cede02f1467fb4f6ac04656dbd.png";